import React from "react";

export default function Catagories({ categories, filterItems }) {
  return (
    <div className="btn-container">
      {categories.map((item, id) => {
        return (
          <button
            className="filter-btn"
            key={id}
            onClick={() => filterItems(item)}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
}
